<template>
  <a
    v-if="showAdd"
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    href="#"
    @click.stop.prevent="addBookmark">{{$t('Star')}}</a>
  <a
    v-else
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    href="#"
    @click.stop.prevent="removeBookmark">{{$t('Unstar')}}</a>
</template>

<script>
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import { mapStores } from 'pinia'
import addBookmark from '../../../mixins/actions/AddBookmark'
import removeBookmark from '../../../mixins/actions/RemoveBookmark'

export default {
  emits: ['onselect'],
  props: ['item'],
  data() {
    return {}
  },
  computed: {
    showAdd () {
      return !this.bcBookmarkStore.isBookmarked(this.item) 
    },
    ...mapStores(useBcBookmarkStore),
  },
  methods: {
    addBookmark() {
      const documents = []
      const folders = []

      if (this.item.type === 'document') {
        documents.push(this.item)
      } else {
        folders.push(this.item)
      }

      addBookmark(documents, folders)
      this.$emit('onselect')
    },
    removeBookmark() {
      const documents = []
      const folders = []

      if (this.item.type === 'document') {
        documents.push(this.item)
      } else {
        folders.push(this.item)
      }

      removeBookmark(documents, folders)
      this.$emit('onselect')
    }
  },
}
</script>

<style lang="scss" scoped></style>
